import React from 'react';

import toUpperFirst from 'utils/toUpperFirst';
import startcase from 'lodash.startcase';

import Heading from 'grommet/components/Heading';
import Box from 'grommet/components/Box';
import FormField from 'grommet/components/FormField';

import Conditional from 'components/Conditional';

import TextInput from 'elements/TextInput';
import Datepicker from 'elements/Datepicker';
import Error from 'elements/Error';

import { fallManure, springManure } from 'containers/FieldSubmission';

export default function({
  state,
  value,
  name,
  season,
  onChange,
  onChangeDate,
  onFocusChange,
  toggleSection,
  prefix,
}) {
  const fields = {
    fall: fallManure(prefix),
    spring: springManure(prefix),
  };

  return (
    <Conditional
      id={name(`${season}_manure`)}
      label={`${toUpperFirst(season)} manure applied`}
      onChange={s => toggleSection(s, name(`${season}_manure`), fields[season])}>
      <Heading tag="h4" margin="small">{startcase(season)} Manure Applications</Heading>
      <Error>{state.errors[name(`${season}_manure`)]}</Error>
      <Box>
        <FormField
          error={state.errors[name(`${season}_manure_animal`)]}
          label="Type">
          <select
            onChange={onChange}
            value={value(`${season}_manure_animal`) || ''}
            name={name(`${season}_manure_animal`)}>
            <option value=""></option>
            <option>Hog</option>
            <option>Cattle</option>
            <option>Poultry</option>
          </select>
        </FormField>
        <Box direction="row">
          <FormField
            error={state.errors[name(`${season}_manure_gallons`)]}
            label="Gallons">
            <TextInput
              onChange={onChange}
              value={value(`${season}_manure_gallons`)}
              name={name(`${season}_manure_gallons`)} />
          </FormField>
          <FormField
            error={state.errors[name(`${season}_manure_tons`)]}
            label="Tons">
            <TextInput
              onChange={onChange}
              value={value(`${season}_manure_tons`)}
              name={name(`${season}_manure_tons`)} />
          </FormField>
        </Box>
      </Box>
      <FormField label="Pounds of Nitrogen per acre from Manure">
        <TextInput
          onChange={onChange}
          value={value(`${season}_pounds_n_manure`)}
          name={name(`${season}_pounds_n_manure`)} />
      </FormField>
      <Datepicker
        label="Date of Application"
        season={season}
        error={state.errors[name(`${season}_manure_application_date`)]}
        id={name(`${season}_manure_application_date`)}
        value={value(`${season}_manure_application_date`)}
        focused={state[`${name(`${season}_manure_application_date`)}Focused`]}
        onDateChange={onChangeDate(name(`${season}_manure_application_date`))}
        onFocusChange={onFocusChange(name(`${season}_manure_application_date`))} />
        <FormField label="Analysis">
        <TextInput
          onChange={onChange}
          value={value(`${season}_manure_analysis`)}
          name={name(`${season}_manure_analysis`)} />
      </FormField>
    </Conditional>
  )
}



// WEBPACK FOOTER //
// ./src/components/Manure.js